/** 허브 일별 통계 엔티티 */
export default class StatsHubDaily {
    /** 아이디 */
    id = 0;
    /** 총판 아이디 */
    distributorId = 0;
    /** 총판 이름 */
    distributorName = '';
    /** 허브 아이디 */
    hubId = '';
    /** 허브 이름 */
    hubName = '';
    /** 날짜 */
    date = '';
    /** 상품 매출액 전체 */
    orderAmount = 0;
    /** 상품 객단가 전체 */
    orderAmountAverage = 0;
    /** 분류별 완료건수 전체 */
    // doneCountPerCategoryAll: number = 0;
    /** 배달대행료 전체 */
    deliveryCharge = 0;
    /** 배달대행료 평균 */
    deliveryChargeAverage = 0;
    /** 완료 건수 전체 */
    completeCount = 0;
    /** 완료 건수 현금 */
    cashCount = 0;
    /** 완료 건수 카드 */
    cardCount = 0;
    /** 완료 건수 마일리지 */
    mileageCount = 0;
    /** 완료 건수 크레딧 */
    laterCount = 0;
    /** 완료 건수 현금 비율 */
    cashRatio = 0;
    /** 완료 건수 카드 비율 */
    cardRatio = 0;
    /** 완료 건수 마일리지 비율 */
    mileageRatio = 0;
    /** 완료 건수 크레딧 비율 */
    laterRatio = 0;
    /** 취소 건수 */
    cancelCount = 0;
    constructor(_data = {}) {
        Object.assign(this, _data);
    }
}
